// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Staatliches&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ci-table-wrapper {
  overflow-x: auto;
  margin-top: 1rem;
}

.ci-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  background-color: var(--hellgruen);
  border-radius: 12px;
  overflow: hidden;
}

.ci-table thead th {
  background-color: var(--dunkelgruen);
  color: var(--blassgruen);
  font-size: calc(1rem + 2px);
}

.ci-table th,
.ci-table td {
  padding: 0.75rem;
  text-align: center;
  border: none;
  font-weight: normal;
  font-family: 'Circular', sans-serif;
}

.ci-table th {
  font-family: 'Staatliches', sans-serif;
  font-weight: normal;
}

.ci-table td {
  font-size: calc(1rem - 2px);
  color: var(--dunkelgruen);
}


.ci-table th:first-child,
.ci-table td:first-child {
  text-align: left;
}

.ci-table tbody tr:nth-child(even) {
  background-color: var(--blassgruen);
}

/* Klickbare Zeilen (z.B. Kinderliste -> Kind-Detailseite) */
.ci-table tbody tr.clickable-row {
  cursor: pointer;
}

.ci-table tbody tr.clickable-row:hover td {
  background-color: var(--dunkelgruen);
  color: var(--blassgruen);
}

/* Zelt-Spalte: Zeltname + Betreuer untereinander */
.zelt-cell {
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
}

.zelt-name {
  font-weight: 600;
}

.zelt-betreuer {
  font-size: 0.85em;
  opacity: 0.75;
}

/* Mobile-Optimierung der Kindersuche-Tabelle */
@media (max-width: 600px) {
  .ci-table-wrapper {
    overflow-x: visible;
  }

  .kindersuche-table {
    table-layout: fixed;
    width: 100%;
  }

  .kindersuche-table th,
  .kindersuche-table td {
    padding: 0.5rem 0.4rem;
    font-size: calc(1rem - 3px);
    word-break: break-word;
    overflow-wrap: anywhere;
  }

  .kindersuche-table thead th {
    font-size: 1rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/CiTable.css"],"names":[],"mappings":"AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,kCAAkC;EAClC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;;EAEE,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA;EACE,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;AAC3B;;;AAGA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;AACrC;;AAEA,4DAA4D;AAC5D;EACE,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,wBAAwB;AAC1B;;AAEA,mDAAmD;AACnD;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,aAAa;AACf;;AAEA,+CAA+C;AAC/C;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,WAAW;EACb;;EAEA;;IAEE,sBAAsB;IACtB,2BAA2B;IAC3B,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Staatliches&display=swap');\n\n.ci-table-wrapper {\n  overflow-x: auto;\n  margin-top: 1rem;\n}\n\n.ci-table {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n  background-color: var(--hellgruen);\n  border-radius: 12px;\n  overflow: hidden;\n}\n\n.ci-table thead th {\n  background-color: var(--dunkelgruen);\n  color: var(--blassgruen);\n  font-size: calc(1rem + 2px);\n}\n\n.ci-table th,\n.ci-table td {\n  padding: 0.75rem;\n  text-align: center;\n  border: none;\n  font-weight: normal;\n  font-family: 'Circular', sans-serif;\n}\n\n.ci-table th {\n  font-family: 'Staatliches', sans-serif;\n  font-weight: normal;\n}\n\n.ci-table td {\n  font-size: calc(1rem - 2px);\n  color: var(--dunkelgruen);\n}\n\n\n.ci-table th:first-child,\n.ci-table td:first-child {\n  text-align: left;\n}\n\n.ci-table tbody tr:nth-child(even) {\n  background-color: var(--blassgruen);\n}\n\n/* Klickbare Zeilen (z.B. Kinderliste -> Kind-Detailseite) */\n.ci-table tbody tr.clickable-row {\n  cursor: pointer;\n}\n\n.ci-table tbody tr.clickable-row:hover td {\n  background-color: var(--dunkelgruen);\n  color: var(--blassgruen);\n}\n\n/* Zelt-Spalte: Zeltname + Betreuer untereinander */\n.zelt-cell {\n  display: flex;\n  flex-direction: column;\n  gap: 0.15rem;\n}\n\n.zelt-name {\n  font-weight: 600;\n}\n\n.zelt-betreuer {\n  font-size: 0.85em;\n  opacity: 0.75;\n}\n\n/* Mobile-Optimierung der Kindersuche-Tabelle */\n@media (max-width: 600px) {\n  .ci-table-wrapper {\n    overflow-x: visible;\n  }\n\n  .kindersuche-table {\n    table-layout: fixed;\n    width: 100%;\n  }\n\n  .kindersuche-table th,\n  .kindersuche-table td {\n    padding: 0.5rem 0.4rem;\n    font-size: calc(1rem - 3px);\n    word-break: break-word;\n    overflow-wrap: anywhere;\n  }\n\n  .kindersuche-table thead th {\n    font-size: 1rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
